import { inject, observer } from 'mobx-react';
import React, { Component, Fragment } from 'react';
import './style.scss';

const Button = inject('ChatBotStore')(
  observer(
    class Button extends Component {

      writeLabel = () => {
        const { copy, label, destination, variant } = this.props
        let title = label || copy
        if (variant === 'download') {
          const filesize = `≈${((destination.filesize / 1024) / 1000).toFixed(2)}Mb`
          title = `${title} (${filesize})`
        }
        return title
      }

      reactifyUrl = (destination) => {
        // @TODO: This could probably be better!
        const offset = (destination.slice(-1) === '/') ? 2 : 1
        const arr = destination.split('/')
        const length = arr.length
        const lastitem = arr[length - offset]
        return lastitem
      }

      onDownload = (destination) => {

      }

      render() {
        const { copy, id, variant, destination, ChatBotStore: { openChatbot, closeChatbotModal } } = this.props
        const classes = "button";
        let formatName;
        if (destination.title && variant === 'download') {
          formatName = destination.title.replace(/\s/g, "-").toLowerCase();
        }

        return (
          <Fragment>
            {variant === 'chatbot' && <button onClick={openChatbot} id={id} className={classes} title={this.writeLabel()} aria-label={this.writeLabel()}>{copy}</button>}
            {variant === 'chatbot:modal' && <button onClick={closeChatbotModal} id={id} className={classes} title={this.writeLabel()} aria-label={this.writeLabel()}>{copy}</button>}
            {variant === 'internal' && <a id={id} className={classes} title={this.writeLabel()} aria-label={this.writeLabel()} href={this.reactifyUrl(destination)}>{copy}</a>}
            {variant === 'external' && <a id={id} className={classes} title={this.writeLabel()} aria-label={this.writeLabel()} href={destination} target="_blank" rel="nofollow noopener noreferrer">{copy}</a>}
            {variant === 'download' && <a id={formatName || id} className={classes}
              title={this.writeLabel()}
              aria-label={this.writeLabel()}
              href={destination.url}
              target="_blank"
              rel="noopener noreferrer"
              download>{copy}</a>}
          </Fragment>
        )
      }
    }
  )
)

export default Button;
